import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { getColor } from '../../../../utils/colors.mjs';
import { ScrollArea } from '../../../scroll-area/ScrollArea.mjs';
import { fog } from '../../../scroll-area/scrollArea.vanilla.mjs';

const ModalFog = forwardRef(
  ({
    color: colorFromProps = "white",
    className: classNameFromProps,
    ...props
  }, ref) => {
    const color = getColor(colorFromProps);
    return /* @__PURE__ */ jsx(
      ScrollArea.Fog,
      {
        className: classNames(fog, classNameFromProps),
        color,
        side: "bottom",
        ref,
        ...props
      }
    );
  }
);

export { ModalFog };
//# sourceMappingURL=Fog.mjs.map
